import { render, staticRenderFns } from "./bulma_container.vue?vue&type=template&id=f9ffef0c&scoped=true&lang=html"
import script from "./bulma_container.vue?vue&type=script&lang=js"
export * from "./bulma_container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ffef0c",
  null
  
)

export default component.exports